export default {"src":"/_next/static/media/arrow-topics.912fc98b.svg","height":11,"width":19,"blurWidth":0,"blurHeight":0};